const SponsorsData = [

    {img : require('../../../../Images/client-image1.png')},
    {img : require('../../../../Images/client-image2.png')},
    {img : require('../../../../Images/client-image3.png')},
    {img : require('../../../../Images/client-image4.png')},
    {img : require('../../../../Images/client-image5.png')},

];

export default SponsorsData;